<template>
    <div>
        <v-layout wrap justify-center align-center>
            <v-flex md7 sm7 xs12>
                <dialogos-app :dialogos="dialogos" tucan="0"></dialogos-app>
            </v-flex>
        </v-layout>
        <v-layout wrap row pb-5 justify-center align-center class="cont_page animated fadeIn dura-1">
          <v-flex xs11 sm7 md7 mb-2 text-xs-center v-for="i in 6" :key="'expand'+i">
            <div class="item-btn-modal btn-orange hvr hvr" @click="expandAction(i-1)" :class="{'btnexpandvisto':vistos[i-1]}">
                <span>{{contExpand.titulo[i-1]}}</span>
                <v-icon class="icon" size="30" color="#FFF" :class="{'icon-active':expand[i-1]}">navigate_next</v-icon>
            </div>
            <v-expand-transition>
              <div class="cont-item-modal" v-show="expand[i-1]">
                <p>{{contExpand.texto[i-1]}}</p>
                <!-- <img :src="require('@/assets/unidad1/slide-17/slide-17-'+i+'.png')" alt=""> -->
                <p class="mt-1"><span class="nolist" v-html="contExpand.nombre[i-1]"></span></p>
              </div>
            </v-expand-transition>
          </v-flex>
        </v-layout>
    </div>
</template>
<script>
import nextConditions from "../../js/mixins/nextConditions";
export default {
  mixins: [nextConditions],
  data() {
    return {
      dialogos: [
        'Para os nomes próprios geográficos existem as seguintes regras:',
        'Clique avançar e faça a atividade.'
      ],
      expand:Array(6).fill(false),
      contExpand:{ 
        titulo:['Continentes','Países','Exceção de países','Cidade','Exceção de cidades','Dentro da Cidade'],
        texto:[
          'Os continentes sempre têm artigo definido feminino.',
          'Nomes de países podem ser acompanhados por artigos definidos.',
          'Alguns países não têm artigo.',
          'Nomes de cidades não têm artigo.',
          'Algumas cidades têm artigo.',
          'Lugares dentro das cidades, sempre têm artigo definido.'
        ],
        nombre:[
          '<ul><li>A África</li><li>A América</li><li>A Antártica</li><li>A Ásia</li><li>A Europa</li><li>A Oceania</li></ul>',
          '<ul><li><strong>A</strong> Argentina</li><li><strong>A</strong> Colômbia</li><li><strong>A</strong> Inglaterra</li><li><strong>A</strong> China</li><li><strong>O</strong> Afeganistão</li><li><strong>O</strong> Irã</li><li><strong>O</strong> Brasil</li><li><strong>O</strong> Chile</li><li><strong>Os</strong> Estados Unidos</li><li><strong>O</strong> México</li><li><strong>O</strong> Panamá</li></ul>',
          '<ul><li>Marrocos</li><li>Portugal</li><li>Israel</li><li>Cuba</li><li>Angola</li></ul>',
          '<ul><li>Paris</li><li>Cali</li><li>Roma</li><li>Milão</li></ul>',
          '<ul><li>O Rio de Janeiro</li><li>O Porto</li><li>O Recife</li><li>O Cairo</li></ul>',
          '<ul><li>A ponte</li><li>A ciclovia</li><li>O bairro</li><li>A rodovia</li></ul>'                                                       
        ],
      },
      vistos:Array(6).fill(false)
    }
  },
  methods: {
    expandAction(val){
      this.expand = Array(6).fill(false)
      this.$set(this.expand,val,true)
      this.$set(this.vistos,val,true)
      console.log(this.vistos)
    }
  },
}
</script>
<style lang="scss" scoped>
// NOT SCOPED !!
@import '../../sass/globals';

.item-btn-modal{
    color: #D37A1C;
    border-radius: 4px 4px 0px 0px;
    position: relative;
    padding-right: 22px;
    .icon{
    position: absolute;
    right: 0;
    top: 23%;
    transition: all 0.3s ease-out;
    transform: rotate(0deg);
    }
    span{
        font-family: Poppins-Bold;
        color: black;
    }
}
.icon-active{
    transform: rotate(90deg)!important;
}
.cont-item-modal{
    padding: 5px 0px;
    transition:all 0.4s ease-out;
    padding: 10px;
    outline: none;
    border-radius: 0px 0px 4px 4px;
    border: solid #D37A1C 2px;
    p{
      color: #504B4A;
      font-family: Poppins-Italic;
      font-size: 12px;
      margin: 0;
      padding: 0;
    }
    img{
      width: 100px;
      margin: 5px 0px;
    }
}


</style>
